import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { PrivacyModal } from './PrivacyModal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-forest-dark text-white relative" data-id="element-49">
      {/* Decorative Top Border */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-gold-dark via-gold to-gold-dark" data-id="element-50"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12" data-id="element-51">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-52">
          {/* Brand Column */}
          <div className="md:col-span-5 flex flex-col items-center text-center" data-id="element-53">
            <div className="mb-8" data-id="element-54">
              <img src="https://cdn.magicpatterns.com/uploads/qjezKWzXwRTWNbzJPAMi1d/heylloyd-image-1777156728976.png" alt="Manny's The Green Mountain Landscaping Logo" className="h-20 w-auto object-contain" data-id="element-55" />
            </div>
            <p className="text-gray-300 mb-8 text-lg font-light leading-relaxed max-w-md" data-id="element-56">
              Premium landscaping and hardscaping services across Washington
              State. Professional results you can trust, built on years of local
              expertise.
            </p>
            <div className="flex items-center gap-4 text-lg font-medium group w-fit" data-id="element-57">
              <div className="w-12 h-12 bg-forest rounded-full flex items-center justify-center group-hover:bg-gold transition-colors duration-300" data-id="element-58">
                <PhoneIcon className="w-5 h-5 text-gold group-hover:text-forest-dark transition-colors duration-300" data-id="element-59" />
              </div>
              <a href="tel:360-623-4531" className="hover:text-gold transition-colors text-xl" data-id="element-60">
                360-623-4531
              </a>
            </div>
          </div>

          {/* Quick Links */}

          {/* CTA Column */}
          <div className="md:col-span-3" id="contact" data-id="element-61">
            <div className="bg-forest p-8 rounded-3xl border border-forest-light shadow-2xl relative overflow-hidden" data-id="element-62">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-63"></div>
              <h4 className="text-2xl font-bold mb-4 text-white font-serif relative z-10" data-id="element-64">
                Start Your Project
              </h4>
              <p className="text-gray-300 mb-8 relative z-10 font-light" data-id="element-65">
                Text or Call for a Quick Quote! We're ready to discuss your
                vision.
              </p>
              <a href="tel:360-623-4531" className="relative z-10 block w-full bg-gold hover:bg-gold-light text-forest-dark text-center font-bold py-4 rounded-xl transition-all duration-300 text-lg shadow-[0_0_20px_rgba(194,165,94,0.3)] hover:shadow-[0_0_30px_rgba(194,165,94,0.5)]" data-id="element-66">
                Call Now
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-400" data-id="element-67">
          <p data-id="element-68">
            &copy; {new Date().getFullYear()} Manny's The Green Mountain
            Landscaping. All rights reserved.
          </p>
          <div className="flex gap-8" data-id="element-69">
            <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-gold transition-colors" data-id="element-70">
              Privacy Policy
            </button>
            <button onClick={() => setIsTermsOpen(true)} className="hover:text-gold transition-colors" data-id="element-71">
              Terms of Service
            </button>
          </div>
        </div>
      </div>

      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Privacy Policy" data-id="element-72" />
      <PrivacyModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms of Service" data-id="element-73" />
    </footer>;
}